import { render, staticRenderFns } from "./Fixed.vue?vue&type=template&id=5e96b518&scoped=true"
import script from "./Fixed.vue?vue&type=script&lang=js"
export * from "./Fixed.vue?vue&type=script&lang=js"
import style0 from "./Fixed.vue?vue&type=style&index=0&id=5e96b518&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96b518",
  null
  
)

export default component.exports